import React, { useRef, useState, useEffect } from "react";
import swal from "sweetalert";
import DisplayUploadedFiles from "../../common/DisplayUploadedFiles";
import DocumentContainer from "../../../UI Component/DocumentViewer/DocumentCotainer";
import DragAndDrop from "../../common/DragAndDrop";
import "./umpView.scss";
import { APPLICABLE_ROLE } from "../../../DashboardAppointmentsView/Constant";
import { SHARE_MANUAL_PRESCRIPTION } from "../../../ViewDocuments/ViewDocumentsApiHandler/apiConstants";
import { GET_MANUAL_RX } from "../../ERXViewApiHandler/apiConstants";
import ShareManualRxModal from "../../../ManualRX/ShareManualRxMoadal";
import { getSignedUrl } from "../../../../Util/API Calls/SignedAPIUrl";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../../../Util/Helper/C2CConsole";
import { c2cPostApiHandler } from "../../../../Util/c2cApiHandler";
import ShareWithPharmacyBtn from "../../common/ShareWithPharmacyBtn";

const UMPView = (props) => {
  const {
    appointmentData,
    fileList,
    defaultPharmacy,
    pharmacyList,
    prescriptionState,
    handleOnDrag,
    handleDeleteFile,
    handleFileChange,
    setFileList,
    setAlertMessage,
    handleSharePharmacyBtn,
  } = props;

  const user_type = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  const staff_id = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  const user_id = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  const inputRef = useRef(null);
  const [documentShow, setDocumentShow] = useState(false);
  const [fileUrl, setFileUrl] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileType, setFileType] = useState("");
  const [fullView, setFullView] = useState(false);
  const [showRxModal, setShowRxModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  // Actions ===>

  const viewDocument = (fileURL, fileName, fileType) => {
    setDocumentShow(true);
    setFileUrl(fileURL);
    setFileName(fileName);
    setFileType(fileType);
  };

  const closeNotification = () => {
    setDocumentShow(false);
    setFileUrl("");
    setFileName("");
    setFileType("");
    setFullView(false);
  };

  const handleOpenFile = () => {
    inputRef.current.click();
  };

  useEffect(() => {
    getUploadedFiles();
  }, []);

  const handleDefaultAlertMessage = () => {
    setTimeout(() => {
      setAlertMessage({
        show: false,
        title: "",
        content: "",
        type: "",
      });
    }, 2000);
  };

  // <===

  // Api Calls ===>

  const getUploadedFiles = () => {
    let reqPayload = {
      user_type: user_type === APPLICABLE_ROLE.STAFF ? "4" : "1",
      user_id:
        user_type === APPLICABLE_ROLE.STAFF
          ? staff_id
          : appointmentData?.doctor_id,
      appointment_id: appointmentData?.appointment_id,
    };
    const resData = c2cPostApiHandler(GET_MANUAL_RX, reqPayload);
    resData.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200 && res?.data?.data?.length > 0) {
          res.data.data.forEach((data) => {
            let lastInd = data.document_title.lastIndexOf(".");
            data.fileName = data.document_title.substring(0, lastInd);
            data.fileType = data.document_title.substring(lastInd + 1);
          });
          setUploadedFiles(res.data.data);
        } else {
          setUploadedFiles([]);
        }
      } else {
        setUploadedFiles([]);
      }
    });
  };

  const shareDocument = (doc) => {
    let data = {
      doc_data: doc.document_path,
      file_size: doc.file_size,
      doc_title: doc.document_title,
    };
    let params = {};

    if (appointmentData?.doctor_id || user_id) {
      params["doctor_id"] = appointmentData?.doctor_id
        ? appointmentData?.doctor_id
        : user_id;
    }
    let reqPayload = {
      user_type: user_type === APPLICABLE_ROLE.STAFF ? "4" : "1",
      user_id: user_type === APPLICABLE_ROLE.STAFF ? staff_id : user_id,
      ...params,
      appointment_id: doc.appointment_id,
      prescriptions: [data],
      document_id: doc.document_id,
      prescription_status:
        uploadedFiles.length > 0 || prescriptionState?.isERxCreated
          ? "edited"
          : "created",
    };
    setLoader(true);
    let resData = c2cPostApiHandler(SHARE_MANUAL_PRESCRIPTION, reqPayload);
    resData.then(([res, err]) => {
      setLoader(false);
      if (!err) {
        if (res.data.statusCode === 200) {
          setShowRxModal(true);
        }
      }
    });
  };

  const handleUpload = async () => {
    setLoader(true);
    const manualRx = await fileCheckUploadManualRX(fileList);

    let params = {};

    if (appointmentData?.doctor_id || user_id) {
      params["doctor_id"] = appointmentData?.doctor_id
        ? appointmentData?.doctor_id
        : user_id;
    }
    let reqPayload = {
      user_type: user_type === APPLICABLE_ROLE.STAFF ? "4" : "1",
      user_id: user_type === APPLICABLE_ROLE.STAFF ? staff_id : user_id,
      ...params,
      appointment_id: appointmentData?.appointment_id,
      prescriptions: manualRx,
      prescription_status:
        uploadedFiles.length > 0 || prescriptionState?.isERxCreated
          ? "edited"
          : "created",
    };

    let resData = c2cPostApiHandler(SHARE_MANUAL_PRESCRIPTION, reqPayload);
    resData.then(([res, err]) => {
      setLoader(false);
      if (defaultPharmacy) {
        setAlertMessage({
          show: true,
          title: "",
          content: {
            __html: `Patient’s prescription has been shared successfully with the pharmacy`,
          },
          type: "success",
        });

        handleDefaultAlertMessage();
      }
      if (!err) {
        if (res.data.statusCode === 200) {
          getUploadedFiles();
          setFileList([]);
          swal({
            title: "Prescription Uploaded Successfully",
            icon: "success",
            timer: 2000,
          });
        }
      }
    });
  };

  const fileCheckUploadManualRX = async (files) => {
    let prec = [];
    for (const file of files) {
      try {
        const signedUrl = await getSignedUrl(
          {
            file_size: file.size,
            doc_title: file.name,
            user_type: user_type,
            use_case: "upload-prescription-rev1",
          },
          file.fileDate
        );

        if (signedUrl) {
          if (signedUrl.statusCode) {
            prec.push({ error: signedUrl.statusCode });
            return prec;
          }
          prec.push({
            file_size: file.size,
            doc_title: file.name,
            doc_data: signedUrl.fields["key"],
          });
        }
      } catch (error) {
        C2CConsole.error(error);
      }
    }
    if (prec.length == files.length) return prec;
  };

  // <===

  // Display UI ===>

  const displayUploadManualPrescription = () => {
    return (
      <div>
        {displayDragAndDrop()}
        {uploadedFiles.length !== 0 && displayFilesUploaded()}
      </div>
    );
  };

  const displayDragAndDrop = () => {
    return (
      <div>
        <DragAndDrop
          fileList={fileList}
          handleDeleteFile={handleDeleteFile}
          handleOnDrag={handleOnDrag}
          handleOpenFile={handleOpenFile}
          handleUpload={handleUpload}
        />
      </div>
    );
  };

  const displayShareWithPharmacyBtnUI = (file) => {
    return (
      <>
        {pharmacyList.length > 0 && (
          <ShareWithPharmacyBtn
            handleSharePharmacyBtn={() =>
              handleSharePharmacyBtn(file?.document_id, "rx")
            }
          />
        )}
      </>
    );
  };

  const displayFilesUploaded = () => {
    return (
      <div>
        <div
          className="uploaded-file-header"
          style={{
            marginTop:
              fileList.length !== 0 && window.innerWidth > 767 ? "5px" : "",
          }}
        >
          Files
        </div>
        <div className="uploaded-files-container">
          {uploadedFiles.map((file) => (
            <div className="uploaded-files-cont" key={file.document_id}>
              <DisplayUploadedFiles
                data={file}
                fileName={file.fileName}
                fileType={file.fileType}
                fileSize={file.file_size + "MB"}
                downloadUrl={file.presigned_url}
                fileDateTime={file.created_at.split("+")[0]}
                viewDocument={() =>
                  viewDocument(
                    file.presigned_url_view,
                    file.fileName,
                    file.fileType
                  )
                }
                shareDocument={shareDocument}
                displaySubContent={displayShareWithPharmacyBtnUI(file)}
              />
            </div>
          ))}
        </div>
      </div>
    );
  };

  // <===

  return (
    <div className="upload-manual-prescription-cont">
      {loader && (
        <div className="loader-container">
          <div className="load-loader">
            <div className="spinner-border text-dark" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      )}
      {displayUploadManualPrescription()}
      {documentShow && (
        <DocumentContainer
          cancelHandler={closeNotification}
          fullViewHandler={() => {
            setFullView(!fullView);
          }}
          url={fileUrl}
          fileName={fileName}
          fileType={fileType}
          width={""}
        />
      )}
      <input
        ref={inputRef}
        type="file"
        style={{ display: "none" }}
        onChange={handleFileChange}
        multiple={true}
        accept={"image/*, .doc, .docx, .pdf, .txt, .xls, .csv"}
      />
      <ShareManualRxModal
        show={showRxModal}
        handleClose={() => {
          setShowRxModal(false);
        }}
      />
    </div>
  );
};

export default UMPView;
